var exports = {
  "DD": "title__csTPlg",
  "Qw": "titleText__XaOfoX",
  "R_": "heading__KZ0uHi",
  "Cv": "about__iQIv92",
  "Pg": "actionError__BLpMLl",
  "W7": "setupIncomplete__ZvqZdx",
  "zH": "details__IroEDD",
  "_0": "detail__SvCKQM",
  "CD": "detailTerm__JC511A",
  "zL": "detailValue__pOin_t",
  "I8": "statusIcon__7f1t4O",
  "N4": "note__zOrjIZ",
};

module.exports = exports;
